
(() => {
  const tag = 'event-calendar';
  if (customElements.get(tag)) return;
  const zone = 'America/Detroit';
  const months = 'January February March April May June July August September October November December'.split(' ');
  const parts = new Intl.DateTimeFormat('en-US', {timeZone: zone, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23'});
  function appointment(value, productDate = '') {
    let input = String(value || '').trim().replace(/\s+/g, ' ');
    const datePrefix = date => {
      const iso = String(date || '').match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if (iso && +iso[2] >= 1 && +iso[2] <= 12) return `${months[+iso[2]-1]} ${+iso[3]} ${iso[1]}`;
      const us = String(date || '').match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
      if (us && +us[1] >= 1 && +us[1] <= 12) return `${months[+us[1]-1]} ${+us[2]} ${us[3]}`;
      return String(date || '').replace(/^(?:Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday),?\s+/i, '').trim();
    };
    if (/^\d{1,2}:\d{2}\s*(?:AM|PM)$/i.test(input) && productDate) input = `${datePrefix(productDate)} ${input}`;
    input = input.replace(/^(\d{4}-\d{2}-\d{2}|\d{1,2}\/\d{1,2}\/\d{4})[ T]+/, (_, date) => datePrefix(date)+' ');
    input = input.replace(/^(?:Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday),?\s+/i, '').replace(/\s+(?:at|[-–|/])\s+/gi,' ');
    const match = input.match(/^(\w+)\s+(\d{1,2}),?\s+(\d{4})\s+(\d{1,2}):(\d{2})\s*(AM|PM)$/i);
    if (!match) return null;
    const month = months.findIndex(m => m.toLowerCase() === match[1].toLowerCase());
    const day = Number(match[2]), year = Number(match[3]), hour12 = Number(match[4]), minute = Number(match[5]);
    if (month < 0 || day < 1 || day > 31 || hour12 < 1 || hour12 > 12 || minute > 59) return null;
    const hour = hour12 % 12 + (match[6].toUpperCase() === 'PM' ? 12 : 0);
    const target = Date.UTC(year, month, day, hour, minute);
    let start = target;
    for (let i = 0; i < 3; i++) {
      const p = Object.fromEntries(parts.formatToParts(start).map(p => [p.type, p.value]));
      start += target - Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour, +p.minute);
    }
    const p = Object.fromEntries(parts.formatToParts(start).map(p => [p.type, p.value]));
    if (+p.year !== year || +p.month !== month + 1 || +p.day !== day || +p.hour !== hour || +p.minute !== minute) return null;
    return {key: String(start), start, date: `${year}-${String(month+1).padStart(2,'0')}-${String(day).padStart(2,'0')}`, time: `${hour12}:${match[5]} ${match[6].toUpperCase()}`, label: `${months[month]} ${day}, ${year} at ${hour12}:${match[5]} ${match[6].toUpperCase()}`};
  }
  function variantAppointment(variant) {
    const options = (variant.options || []).filter(Boolean);
    for (const value of [variant.title, ...options, options.join(' ')]) {
      const slot = appointment(value, variant.visitDate);
      if (slot) return slot;
    }
    for (const time of options) for (const date of options) {
      if (time === date) continue;
      const slot = appointment(time, date);
      if (slot) return slot;
    }
    return null;
  }
  function ticketVariants(data, role) {
    return data.products.filter(p => p.tags.includes(role)).flatMap(p => p.variants.map(v => ({...v, visitDate: p.visitDate || '', productTitle: p.title || '', image: p.image || null})));
  }
  function diagnosis(data) {
    const child = ticketVariants(data, 'participating_child'), adult = ticketVariants(data, 'non_participating');
    if (!child.length) return 'No ticket appointments are available yet. Please check again shortly.';
    const read = child.filter(v => variantAppointment(v));
    if (!read.length) return 'Ticket dates could not be loaded. Please contact the farm.';
    if (data.mode === 'dear_santa' && !adult.length) return 'No adult ticket variants were loaded. Select an adult-ticket collection or the fallback adult product.';
    const all = slots(data, {items: []});
    const reasons = [...new Set(all.map(s => s.reason).filter(Boolean))];
    if (reasons.length) return reasons.join(' ');
    return '';
  }
  function slots(data, cart, now = Date.now()) {
    const child = ticketVariants(data, 'participating_child');
    const adult = ticketVariants(data, 'non_participating');
    const group = variants => {
      const result = new Map();
      for (const variant of variants) {
        const slot = variantAppointment(variant);
        if (!slot) continue;
        if (!result.has(slot.key)) result.set(slot.key, {slot, variants: []});
        result.get(slot.key).variants.push(variant);
      }
      return result;
    };
    const adultGroups = group(adult);
    return [...group(child).values()].map(({slot, variants}) => {
      const matches = adultGroups.get(slot.key)?.variants || [];
      const c = variants[0], santa = data.mode === 'dear_santa', a = santa ? matches[0] : {available:true,price:0};
      const reason = variants.length !== 1 ? 'More than one ticket variant matches the same appointment.'
        : santa && matches.length === 0 ? 'An adult variant is missing for a child appointment. Adult variants need the matching date and time.'
        : santa && matches.length !== 1 ? 'More than one adult variant matches the same appointment.'
        : santa && c.id === a.id ? 'Choose separate child and adult products.'
        : santa && !c.managed ? 'Enable inventory tracking on participating-child variants.'
        : santa && c.policy !== 'deny' ? 'Turn off Continue selling when out of stock for participating-child variants.'
        : santa && a.managed ? 'Turn off inventory tracking for adult/non-participating variants.' : '';
      const configured = !reason;
      const inCart = cart.items.filter(i => String(i.variant_id) === String(c.id)).reduce((n,i) => n+i.quantity,0);
      const remaining = c.available ? (c.managed && c.policy === 'deny' ? Math.max(0, Number(c.inventory)-inCart) : Number.MAX_SAFE_INTEGER) : 0;
      return {...slot, child: c, adult: a, configured, reason, remaining, inCart, cartOnly: configured && c.available && Number(c.inventory) > 0 && remaining === 0 && inCart > 0 && a.available && slot.start > now, available: configured && remaining > 0 && a.available && slot.start > now};
    }).sort((a,b) => a.start-b.start);
  }
  const positive = n => Number.isSafeInteger(n) && n >= 1;
  function itemsFor(slot, children, adults, reference, names, mode = 'dear_santa') {
    if (!slot?.available || slot.start <= Date.now() || !positive(children) || children > slot.remaining || (mode === 'dear_santa' ? !positive(adults) : adults !== 0)) throw new Error('Choose an available time and at least one ticket of each type.');
    if (mode === 'dear_santa' && (!Array.isArray(names) || names.length !== children || names.some(name => !name.trim() || name.length > 100))) throw new Error('Enter a name for each participating child.');
    const childNames = Object.fromEntries(names.map((name,index) => [`Child ${index+1} name`, name.trim()]));
    const properties = {'Appointment': slot.label};
    if (mode === 'dear_santa') properties._dear_santa_booking = reference;
    if (mode !== 'dear_santa') return [{id:slot.child.id,quantity:children,properties}];
    return [{id: slot.child.id, quantity: children, properties: {...properties, ...childNames, _dear_santa_role: 'child'}}, {id: slot.adult.id, quantity: adults, properties: {...properties, _dear_santa_role: 'guest'}}];
  }
  function drinkLimit(offer, variantId, ticketCount, cart) {
    if (!offer?.enabled || !offer.productId || !Number.isSafeInteger(ticketCount) || ticketCount < 1) return 0;
    const variant = offer.variants.find(v => String(v.id) === String(variantId));
    if (!variant?.available) return 0;
    const inCart = cart.items.filter(i => String(i.variant_id) === String(variant.id)).reduce((n,i) => n + i.quantity, 0);
    const limit = offer.limitedToTickets === false ? Number.MAX_SAFE_INTEGER : ticketCount;
    return variant.managed && variant.policy === 'deny' ? Math.min(limit, Math.max(0, Number(variant.inventory) - inCart)) : limit;
  }
  function drinkItems(data, selections, children, adults, cart, properties) {
    const items = [];
    for (const role of ['booking']) {
      const selection = selections[role];
      if (!selection?.yes) continue;
      const offer = data.drinks[role], count = children + adults;
      const max = drinkLimit(offer, selection.variant, count, cart);
      if (!positive(selection.quantity) || selection.quantity > max) throw new Error('The selected drinks are no longer available in that quantity. Review your drink choices and try again.');
      items.push({id: Number(selection.variant), quantity: selection.quantity, properties: {...properties, _dear_santa_role: 'drink_upgrade'}});
    }
    for (const id of new Set(items.map(i => i.id))) {
      const variant = Object.values(data.drinks).flatMap(o => o.variants).find(v => Number(v.id) === id);
      const total = items.filter(i => i.id === id).reduce((n,i) => n + i.quantity,0);
      const inCart = cart.items.filter(i => Number(i.variant_id) === id).reduce((n,i) => n + i.quantity,0);
      if (variant.managed && variant.policy === 'deny' && total + inCart > Number(variant.inventory)) throw new Error('There are not enough specialty drinks for this selection. Reduce the drink quantity and try again.');
    }
    return items;
  }
  function linkedSlots(data, cart, main, now = Date.now()) {
    if (!main || !data.linkedEnabled) return [];
    const grouped = new Map();
    for (const variant of ticketVariants(data, 'linked')) {
      const slot = variantAppointment(variant);
      if (!slot || slot.date !== main.date || slot.start <= main.start) continue;
      if (!grouped.has(slot.key)) grouped.set(slot.key, []);
      grouped.get(slot.key).push({...slot, variant});
    }
    return [...grouped.values()].map(group => {
      const item = group[0], v = item.variant;
      const held = cart.items.filter(line => String(line.variant_id) === String(v.id)).reduce((n,line) => n + line.quantity, 0);
      const remaining = v.available ? (v.managed && v.policy === 'deny' ? Math.max(0, Number(v.inventory) - held) : Number.MAX_SAFE_INTEGER) : 0;
      return {...item, remaining, cartOnly: group.length === 1 && v.available && Number(v.inventory) > 0 && remaining === 0 && held > 0 && item.start > now, available: group.length === 1 && remaining > 0 && item.start > now};
    }).sort((a,b) => a.start - b.start);
  }
  function ticketFee(data, role = 'main') {
    const offer = data.fees;
    if (!offer?.enabled || !Number.isSafeInteger(offer.amount) || offer.amount <= 0) return 0;
    if (role === 'guest' && !offer.guests || role === 'linked' && !offer.linked) return 0;
    return offer.amount;
  }
  function remainingLabel(data, slot) {
    if (data.availability.style === 'none') return '';
    if (data.availability.showCount && slot.available && Number.isSafeInteger(slot.remaining) && slot.remaining > 0 && slot.remaining < Number.MAX_SAFE_INTEGER && slot.remaining <= Number(data.availability.threshold)) {
      return String(data.availability.countLabel || 'Only {count} {tickets} left').replaceAll('{count}', String(slot.remaining)).replaceAll('{tickets}', slot.remaining === 1 ? 'ticket' : 'tickets');
    }
    const low = slot.available && Number.isSafeInteger(slot.remaining) && slot.remaining > 0 && slot.remaining < Number.MAX_SAFE_INTEGER && slot.remaining <= Number(data.availability.threshold);
    if (['smart','low_only'].includes(data.availability.style) && low) return data.availability.low === 'Filling fast' ? 'Almost sold out' : data.availability.low;
    return data.availability.style === 'low_only' ? '' : data.availability.normal;
  }
  function waitlistVisible(data, now = Date.now()) {
    if (data.mode === 'wtl' || data.waitlistMode === 'off') return false;
    if (data.waitlistMode === 'always') return true;
    if (data.waitlistMode !== 'auto' || diagnosis(data)) return false;
    const upcoming = slots(data, {items: []}, now).filter(slot => slot.start > now);
    return upcoming.length > 0 && upcoming.every(slot => slot.configured && slot.child.managed && slot.child.policy === 'deny' && Number.isFinite(Number(slot.child.inventory)) && Number(slot.child.inventory) <= 0);
  }
  window.SharedEventCalendar = {appointment, variantAppointment, diagnosis, slots, itemsFor, drinkLimit, drinkItems, waitlistVisible, linkedSlots, remainingLabel, ticketFee};
  customElements.define(tag, class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.data = JSON.parse(this.querySelector('[data-booking-data]').textContent);
      this.accessGranted = !this.data.access?.enabled;
      this.accessStorageKey = `calendar-access:${this.data.eventCollectionId}:${this.data.sectionId}`;
      this.setupAccess();
      this.querySelector('[data-access-unlock]')?.addEventListener('click', () => this.unlockAccess());
      this.querySelector('[data-access-code]')?.addEventListener('keydown', event => {if(event.key === 'Enter'){event.preventDefault();event.stopPropagation();this.unlockAccess();}});
      this.santa = this.data.mode === 'dear_santa';
      this.linked = {choiceMade: false, yes: false, key: null, quantity: 1};
      this.confirmed = false;
      this.snapshotBusy = false;
      this.lifecycle = 0;
      this.epoch = 0;
      this.cart = {items: []};
      this.drinks = {booking: {yes:false, quantity:0, choiceMade:false}};
      for (const role of ['booking']) this.drinks[role].variant = this.data.drinks[role].variants.find(v => v.available)?.id || this.data.drinks[role].variants[0]?.id;
      this.querySelector('[data-continue-names]')?.addEventListener('click', () => {
        if (!this.validCounts() || !this.validNames()) return;
        this.renderDrinks(); this.summary();
        if (this.data.hasDrinks) this.show('drinks');
        else this.show('summary');
      });
      this.querySelectorAll('[data-drink-choice]').forEach(input => input.addEventListener('click', () => {
        const selected = this.drinks[input.dataset.drinkChoice]; selected.yes = input.dataset.value === 'yes'; selected.choiceMade = true; selected.quantity = selected.yes ? 1 : 0;
        this.renderDrinks(); this.summary();
      }));
      this.querySelectorAll('[data-drink-variant]').forEach(input => input.addEventListener('change', () => {
        this.drinks[input.dataset.drinkVariant].variant = input.value; this.renderDrinks(); this.summary();
      }));
      this.querySelectorAll('[data-drink-delta]').forEach(button => button.addEventListener('click', () => {
        const selected = this.drinks.booking;
        const max = drinkLimit(this.data.drinks.booking,selected.variant,Number(this.childInput.value)+Number(this.adults.value),this.cart);
        selected.quantity = Math.max(1,Math.min(max,selected.quantity+Number(button.dataset.drinkDelta)));
        this.renderDrinks(); this.summary();
      }));
      this.form = this.querySelector('form');
      this.childInput = this.querySelector('[data-children]');
      this.adults = this.querySelector('[data-guests]');
      this.submit = this.querySelector('[data-add]');
      this.day = null;
      this.key = null;
      this.names = [];
      this.loaded = false;
      this.form.addEventListener('submit', event => {event.preventDefault(); this.add();});
      this.querySelector('[data-continue-children]').addEventListener('click', () => {
        if (!this.validCounts()) return;
        if (this.santa) this.renderNames();
        this.renderDrinks();
        if (this.santa) this.show('guests');
        else { this.querySelector('[data-step="guests"]').hidden = false; this.querySelector('[data-step="guests"]').style.display = 'none'; if (this.data.linkedEnabled) this.show('linked'); else if (this.data.hasDrinks) this.show('drinks'); }
        this.summary();
      });
      this.childInput.addEventListener('input', () => {
        this.childInput.setCustomValidity('');
        this.querySelector('[data-step="guests"]').hidden = true;
        if (this.data.hasDrinks) this.querySelector('[data-step="drinks"]').hidden = true;
        if (this.data.linkedEnabled) this.querySelector('[data-step="linked"]').hidden = true;
        this.text('[data-quantity-notice]', '');
        this.renderDrinks();
        this.summary();
      });
      this.adults.addEventListener('input', () => {this.adults.setCustomValidity('');this.renderDrinks();this.summary();});
      this.querySelectorAll('[data-adjust]').forEach(button => button.addEventListener('click', () => {
        const input = button.dataset.adjust === 'children' ? this.childInput : this.adults;
        const next = Number(input.value) + Number(button.dataset.delta);
        if (!positive(next)) return;
        if (input === this.childInput && next > this.selected().remaining) {
          this.text('[data-quantity-notice]', this.quantityMessage(this.selected().remaining, next)); return;
        }
        input.value = String(next); input.dispatchEvent(new Event('input', {bubbles:true}));
      }));
      this.querySelector('[data-change-date]').addEventListener('click', () => {
        this.querySelector('[data-dates]').hidden = false;
        this.querySelector('[data-date-selection]').hidden = true;
        this.show('date');
      });
      this.querySelector('[data-change-time]').addEventListener('click', () => {
        this.querySelector('[data-times]').hidden = false;
        this.querySelector('[data-time-selection]').hidden = true;
        this.show('time');
      });
      this.querySelectorAll('[data-linked-choice]').forEach(button => button.addEventListener('click', () => {
        if (this.locked()) return;
        this.linked.choiceMade = true; this.linked.yes = button.dataset.linkedChoice === 'yes';
        this.renderLinked(); this.summary();
      }));
      this.querySelector('[data-linked-count]')?.addEventListener('input', event => {
        this.linked.quantity = Number(event.target.value); this.summary();
      });
      this.querySelectorAll('[data-linked-delta]').forEach(button => button.addEventListener('click', () => {
        const next = this.linked.quantity + Number(button.dataset.linkedDelta);
        if (!positive(next) || this.locked()) return;
        this.linked.quantity = next; this.querySelector('[data-linked-count]').value = String(next); this.summary();
      }));
      this.querySelector('[data-linked-continue]')?.addEventListener('click', () => {
        if (!this.linkedValid()) {this.error('Choose whether to add Lights, then choose an available time and ticket quantity.'); return;}
        this.error(''); if (this.data.hasDrinks) this.show('drinks'); this.summary();
      });
      this.querySelector('[data-retry]').addEventListener('click', () => this.pending ? this.recover() : this.load());
      this.launchAt = this.data.launch?.enabled ? Date.parse(this.data.launch.at) : null;
      this.launchReady = !this.data.launch?.enabled || Boolean(this.presaleGranted);
      this.launchAttempts = 0;
      this.launchChecking = false;
      this.querySelector('[data-launch-check]')?.addEventListener('click', () => {this.launchAttempts = 0; this.nextLaunchCheck = 0; this.checkLaunch();});
      this.onLaunchVisibility = () => {if (!document.hidden) {this.updateLaunch(); if (this.launchReady) this.poll();}};
      document.addEventListener('visibilitychange', this.onLaunchVisibility);
      if (this.data.launch?.enabled) this.launchTimer = setInterval(() => this.updateLaunch(), 1000);
      this.storageKey = `gmf-booking:${this.data.eventCollectionId}:${this.data.mode}`;
      try {const saved = JSON.parse(sessionStorage.getItem(this.storageKey) || 'null');if (saved && typeof saved.id === 'string' && Array.isArray(saved.items) && saved.items.length) this.pending = saved;} catch {}
      if (this.pending) this.error('We are checking a previous booking request. Please use Check booking before adding more tickets.');
      this.load();
      this.pollTimer = setTimeout(() => this.poll(), 15000 + Math.random() * 10000);
      this.timer = setInterval(() => {if (!this.busy && !this.pending) this.render();}, 30000);
    }
    disconnectedCallback() {this.lifecycle++; clearInterval(this.timer); clearInterval(this.launchTimer); clearTimeout(this.pollTimer); document.removeEventListener('visibilitychange', this.onLaunchVisibility); this.ready = false;}
    locked() {return !this.accessGranted || this.busy || Boolean(this.pending) || Boolean(this.checkoutStarting) || Boolean(this.checkoutBlocked);}
    publicOpen() {return Boolean(this.data.launch?.enabled) && Number.isFinite(Date.parse(this.data.launch.at)) && Date.now() >= Date.parse(this.data.launch.at);}
    setupAccess() {
      this.presaleGranted = false;
      this.accessGranted = !this.data.access?.enabled || this.publicOpen();
      if (this.data.access?.enabled && this.data.access.hash) {
        try {this.presaleGranted = sessionStorage.getItem(this.accessStorageKey) === this.data.access.hash; this.accessGranted ||= this.presaleGranted;} catch {}
      }
      this.toggleAttribute('data-access-blocked', !this.accessGranted);
      const panel = this.querySelector('[data-access-panel]'); if(panel) panel.hidden = this.accessGranted;
      const controls = this.querySelector('[data-booking-controls]'); if(controls) controls.inert = !this.accessGranted;
    }
    async unlockAccess() {
      if (this.accessGranted || this.accessChecking) return;
      this.accessChecking = true;
      const button = this.querySelector('[data-access-unlock]'), input = this.querySelector('[data-access-code]');
      if(button) button.disabled = true;
      try {
        const code = input?.value.trim() || '';
        if (!code || !this.data.access?.hash) throw new Error('Please check your presale access code and try again.');
        const bytes = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(`${code}:${this.data.sectionId}`));
        const hash = Array.from(new Uint8Array(bytes), value => value.toString(16).padStart(2,'0')).join('');
        if(hash !== this.data.access.hash) throw new Error('That access code was not recognized. Please try again.');
        try {sessionStorage.setItem(this.accessStorageKey, hash);} catch {}
        this.presaleGranted = true; this.accessGranted = true; this.launchReady = true; this.removeAttribute('data-access-blocked');
        this.querySelector('[data-access-panel]').hidden = true; input.value = '';
        this.querySelector('[data-booking-controls]').inert = false;
        await this.load();
      } catch(error) {
        this.text('[data-access-status]', error.message || 'Unable to check the access code. Please reload and try again.');
        input?.setAttribute('aria-invalid','true'); input?.focus();
      } finally {this.accessChecking = false; if(button) button.disabled = false;}
    }
    async fetchWithTimeout(url, options = {}) {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 20000);
      try {return await fetch(url, {...options, signal: controller.signal});}
      finally {clearTimeout(timer);}
    }
    async poll() {
      clearTimeout(this.pollTimer);
      const lifecycle = this.lifecycle;
      if (!document.hidden && this.isConnected && this.launchReady && !this.locked() && !this.launchChecking) {
        this.snapshotBusy = true;
        try {await this.refresh(true);this.loaded = true;this.render();}
        catch {this.confirmed = false;this.text('[data-freshness]', '');this.summary();}
        finally {this.snapshotBusy = false;}
      }
      if (this.isConnected && lifecycle === this.lifecycle) this.pollTimer = setTimeout(() => this.poll(), 15000 + Math.random() * 10000);
    }
    linkedSelected() {return linkedSlots(this.data, this.cart, this.selected()).find(slot => slot.key === this.linked.key);}
    linkedValid() {
      if (!this.data.linkedEnabled) return true;
      const slot = this.linkedSelected();
      return this.linked.choiceMade && (!this.linked.yes || Boolean(slot?.available && positive(this.linked.quantity) && this.linked.quantity <= slot.remaining));
    }
    linkedItems(reference) {
      if (!this.data.linkedEnabled || !this.linked.yes) return [];
      if (!this.linkedValid()) throw new Error('The selected Lights time or quantity is no longer available. Please review the Lights choices.');
      const slot = this.linkedSelected();
      return [{id: slot.variant.id, quantity: this.linked.quantity, properties: {'Appointment': slot.label, '_calendar_request': reference, '_calendar_role': 'linked_lights'}}];
    }
    renderLinked() {
      if (!this.data.linkedEnabled) return;
      const choices = linkedSlots(this.data, this.cart, this.selected());
      if (this.linked.key && !choices.some(slot => slot.key === this.linked.key && slot.available)) {
        this.linked.key = null;
        this.error('Your selected Lights time is no longer available. Please choose another Lights time or continue without it.');
      }
      this.querySelectorAll('[data-linked-choice]').forEach(button => {
        button.disabled = this.locked();
        button.setAttribute('aria-pressed', String(this.linked.choiceMade && (button.dataset.linkedChoice === 'yes') === this.linked.yes));
      });
      this.querySelector('[data-linked-details]').hidden = !this.linked.yes;
      const list = this.querySelector('[data-linked-times]');list.replaceChildren();
      const target = this.selected()?.start + 30 * 60 * 1000;
      const recommended = choices.filter(slot => slot.available).sort((a,b) => Math.abs(a.start-target)-Math.abs(b.start-target) || b.start-a.start)[0];
      this.text('[data-linked-guidance]', recommended ? `Suggested Lights time: ${recommended.time}. Choose the time that works for your family.` : 'No later Lights times are currently available for this date. You can continue without adding Lights.');
      for (const slot of choices) {
        if (!slot.available && !slot.cartOnly && this.data.availability.soldTimes === 'hide') continue;
        const button = this.choice(list, `${slot.time}${slot.available ? (remainingLabel(this.data, slot) ? ' · ' + remainingLabel(this.data, slot) : '') : slot.cartOnly ? ' · In your cart — view cart' : ' · Sold out'}`, slot.key === this.linked.key, !slot.available && !slot.cartOnly, 'ticket-time', () => {
          if (slot.cartOnly) {this.goToCart(); return;}
          this.linked.key = slot.key;this.renderLinked();this.summary();
        });
        button.classList.toggle('is-low', slot.available && Boolean(remainingLabel(this.data, slot)) && slot.remaining > 0 && slot.remaining <= Number(this.data.availability.threshold));
        if (slot.key === recommended?.key) {const badge = document.createElement('small');badge.className='ticket-time__recommended';badge.textContent='Suggested';button.append(badge);}
      }
      const selected = this.linkedSelected();
      this.text('[data-linked-price]', selected ? `${this.displayTicketPrice(selected.variant.price, 'linked')} per person` : '');
      this.renderTicketFee('linked', '[data-linked-fee]', selected?.variant.price || 0);
      this.querySelector('[data-linked-count]').disabled=this.locked();
      this.querySelectorAll('[data-linked-delta]').forEach(button=>button.disabled=this.locked() || (button.dataset.linkedDelta === '-1' && this.linked.quantity <= 1));
      this.querySelector('[data-linked-continue]').disabled=this.locked() || !this.linkedValid();
    }
    scrollToFirstQuestion() {
      if (this.initialScrollDone) return;
      const waiting = this.hasAttribute('data-waitlist-active');
      const launching = this.hasAttribute('data-launch-blocked');
      if (!this.accessGranted) return;
      if (!waiting && !launching && !this.loaded) return;
      this.initialScrollDone = true;
      if (!this.data.scrollToBooking || this.data.editorPreview || location.hash || window.scrollY > 80) return;
      requestAnimationFrame(() => {
        if (!this.isConnected || window.scrollY > 80) return;
        const target = this.hasAttribute('data-waitlist-active') ? this.querySelector('[data-waitlist]')
          : this.hasAttribute('data-launch-blocked') ? this.querySelector('[data-launch]')
          : this.querySelector('[data-step="date"]');
        if (!target || target.hidden) return;
        target.scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start'});
      });
    }
    updateLaunch() {
      if (!this.accessGranted && this.publicOpen()) this.setupAccess();
      const panel = this.querySelector('[data-launch]');
      if (!panel) return;
      const manualWaitlist = this.data.waitlistMode === 'always' && this.data.mode !== 'wtl';
      const blocked = !this.launchReady && !manualWaitlist;
      this.toggleAttribute('data-launch-blocked', blocked);
      panel.hidden = !blocked;
      if (!blocked) return;
      if (!Number.isFinite(this.launchAt)) {
        this.text('[data-launch-status]', 'The ticket opening time is being confirmed. Please check back soon.');
        const countdown = this.querySelector('[data-countdown]'); if (countdown) countdown.hidden = true;
        return;
      }
      this.text('[data-launch-date]', new Intl.DateTimeFormat('en-US', {timeZone: zone, month: 'long', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit', timeZoneName: 'short'}).format(this.launchAt));
      const remaining = Math.max(0, Math.ceil((this.launchAt - Date.now()) / 1000));
      for (const [unit, value] of Object.entries({days: Math.floor(remaining/86400), hours: Math.floor(remaining/3600)%24, minutes: Math.floor(remaining/60)%60, seconds: remaining%60})) {
        const node = this.querySelector(`[data-count-${unit}]`); if (node) node.textContent = String(value).padStart(2, '0');
      }
      if (remaining > 0) return;
      const countdown = this.querySelector('[data-countdown]'); if (countdown) countdown.hidden = true;
      this.querySelector('[data-launch-check]').hidden = false;
      if (this.launchAttempts < 24 && Date.now() >= (this.nextLaunchCheck || 0)) this.checkLaunch();
    }
    async checkLaunch() {
      if (!this.accessGranted) return;
      if (this.launchReady || this.launchChecking || this.busy || this.pending || !Number.isFinite(this.launchAt) || Date.now() < this.launchAt) return;
      this.launchChecking = true; this.launchAttempts++;
      const button = this.querySelector('[data-launch-check]'); button.disabled = true;
      this.text('[data-launch-status]', 'Checking ticket availability…');
      try {
        await this.refresh(true);
        const appointments = slots(this.data, {items: []});
        const launchWindow = Date.now() < this.launchAt + 5 * 60 * 1000;
        const datesLoaded = new Set(appointments.map(slot => slot.date)).size;
        if (diagnosis(this.data) || !appointments.length || (launchWindow && datesLoaded < Number(this.data.launch.expectedDates || 1))) throw new Error('Not ready');
        this.launchReady = true; this.loaded = true;
        this.text('[data-status]', ''); this.error('');
        this.querySelector('[data-retry]').hidden = true;
      } catch {
        this.text('[data-launch-status]', this.launchAttempts < 24 ? 'Tickets are still being released. We’ll check again shortly.' : 'Tickets are taking a little longer to appear. Use the button below to check again.');
      } finally {
        this.nextLaunchCheck = Date.now() + 5000 + Math.floor(Math.random()*2000);
        this.launchChecking = false; button.disabled = false;
        this.render();
      }
    }
    text(selector, value) {this.querySelector(selector).textContent = value;}
    money(cents) {return new Intl.NumberFormat('en-US', {style:'currency', currency:this.data.currency || 'USD'}).format(cents/100);}
    error(message) {
      this.text('[data-error]', message);
      const recovery = this.querySelector('[data-cart-recovery]');
      if (recovery) recovery.hidden = !message || !this.pending;
    }
    goToCart() {window.location.assign((window.Shopify?.routes?.root || '/')+'cart');}
    async goToCheckout() {
      if (this.checkoutStarting || this.checkoutBlocked) return;
      this.checkoutStarting = true;
      const status = this.querySelector('[data-checkout-status]');
      const fallback = this.querySelector('[data-checkout-cart]');
      const tell = message => {if (status) status.textContent = message;};
      tell('Reserving your tickets…');
      let slowTimer;
      try {
        if (!customElements.get('meshkit-ticket-holds')) {
          let readyTimer;
          try {
            await Promise.race([customElements.whenDefined('meshkit-ticket-holds'), new Promise((_, reject) => {readyTimer = setTimeout(() => reject(new Error('The ticket reservation service is not ready. Your tickets are in the cart.')), 5000);})]);
          } finally {clearTimeout(readyTimer);}
        }
        const handler = document.querySelector('meshkit-ticket-holds');
        if (!handler || typeof handler.startCheckout !== 'function') throw new Error('The ticket reservation service is unavailable. Your tickets are in the cart.');
        if (handler.busy) throw new Error('A reservation request is already running. Please review your cart before starting checkout again.');
        let appStatus = document.querySelector('[data-meshkit-ticket-hold-status]');
        if (!appStatus) {
          appStatus = document.createElement('p'); appStatus.dataset.meshkitTicketHoldStatus = 'true'; appStatus.setAttribute('role','status');
          (status?.parentElement || this).append(appStatus);
        }
        appStatus.textContent = '';
        slowTimer = setTimeout(() => {
          tell('The reservation is taking longer than usual. Do not submit again. You can review your cart.');
          if (fallback) fallback.hidden = false;
        }, 20000);
        await handler.startCheckout(this.submit);
        if (handler.busy !== true) throw new Error(appStatus.textContent || 'The reservation could not be confirmed. Please start checkout from your cart.');
        tell('MeshTix is opening your checkout…');
      } catch (error) {
        this.checkoutBlocked = true;
        tell(error.message || 'The reservation could not be confirmed. Please start checkout from your cart.');
        if (fallback) fallback.hidden = false;
      } finally {
        clearTimeout(slowTimer);
        if (this.checkoutBlocked) this.checkoutStarting = false;
        this.summary();
      }
    }
    allSlots() {return slots(this.data, this.cart);}
    selected() {return this.allSlots().find(s => s.key === this.key);}
    show(step) {
      const el = step === 'summary' ? this.querySelector('.ds-summary') : this.querySelector(`[data-step="${step}"]`);
      if (!el) return;
      el.hidden = false;
      el.focus({preventScroll:true});
      el.scrollIntoView({block:'start', behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    }
    drinkFee() {
      const offer = this.data.fees;
      return offer?.drinksEnabled && Number.isSafeInteger(offer.drinkAmount) && offer.drinkAmount > 0 ? offer.drinkAmount : 0;
    }
    displayTicketPrice(price, role = 'main') {
      return this.money(price + (this.data.fees?.included ? 0 : ticketFee(this.data, role)));
    }
    renderTicketFee(role, selector, price) {
      const node = this.querySelector(selector); if (!node) return;
      const amount = ticketFee(this.data, role);
      node.hidden = !amount;
      node.textContent = amount ? `${this.money(this.data.fees?.included ? Math.max(0, price - amount) : price)} ticket + ${this.money(amount)} ticket fee` : '';
    }
    quantityMessage(remaining, requested) {
      return String(this.data.copy.insufficient_quantity || 'Only {remaining} left for this time. You requested {requested}. Please reduce your quantity or choose another time.')
        .replaceAll('{remaining}', String(Math.max(0, remaining))).replaceAll('{requested}', String(requested));
    }
    validCounts() {
      const c=Number(this.childInput.value), a=Number(this.adults.value), slot=this.selected();
      const shortage = positive(c) && slot && c > slot.remaining;
      const message = shortage ? this.quantityMessage(slot.remaining, c) : '';
      this.text('[data-quantity-notice]', message);
      this.childInput.setCustomValidity(positive(c) && slot && c<=slot.remaining ? '' : message || 'Choose a valid whole-number ticket quantity.');
      this.adults.setCustomValidity((this.santa ? positive(a) : a === 0) ? '' : 'At least one adult / non-participating ticket is required.');
      return this.childInput.reportValidity() && this.adults.reportValidity();
    }
    validNames() {
      if (!this.santa) return true;
      if (this.querySelectorAll('[data-child-name]').length !== Number(this.childInput.value)) return false;
      this.querySelectorAll('[data-child-name]').forEach(input => input.setCustomValidity(input.value.trim() ? '' : 'Enter this child’s name.'));
      return [...this.querySelectorAll('[data-child-name]')].every(input => input.reportValidity());
    }
    async refreshDrinkDiscounts() {
      const offer = this.data.drinks?.booking;
      if (!this.data.hasDrinks || !offer?.enabled || !offer.productId) return;
      this.drinkPolicies ||= new Map();
      await Promise.all(offer.variants.map(async variant => {
        const key = `${offer.productId}:${variant.id}`, saved = this.drinkPolicies.get(key);
        if (saved && Date.now() - saved.checkedAt < 30000) return;
        const controller = new AbortController(), timeout = setTimeout(() => controller.abort(), 4000);
        try {
          const url = new URL('/apps/meshkit/meshmax', location.origin);
          url.searchParams.set('product_id', String(offer.productId));
          url.searchParams.set('variant_id', String(variant.id));
          const response = await fetch(url, {credentials:'same-origin', cache:'no-store', signal:controller.signal, headers:{Accept:'application/json'}});
          if (!response.ok) throw new Error('Discount unavailable');
          const policy = await response.json();
          this.drinkPolicies.set(key, {checkedAt:Date.now(), policy:policy.ok === true ? policy : null});
        } catch {this.drinkPolicies.set(key, {checkedAt:Date.now(), policy:null});}
        finally {clearTimeout(timeout);}
      }));
    }
    drinkPrice(variant) {
      if (!variant) return 0;
      const policy = this.drinkPolicies?.get(`${this.data.drinks.booking.productId}:${variant.id}`)?.policy;
      const discount = policy?.effectiveScheduledDiscount, base = variant.price;
      if (!discount || discount.active !== true || discount.applyOnline === false || !Number.isSafeInteger(base)) return base;
      const value = Number(discount.value);
      if (!Number.isFinite(value) || value < 0) return base;
      let savings;
      if (discount.valueType === 'percentage' && value <= 100) savings = Math.round(base * value / 100);
      else {
        if (policy.shopCurrency !== this.data.currency) return base;
        if (discount.valueType === 'fixed_amount') savings = Math.round(value * 100);
        else if (discount.valueType === 'target_price') savings = base - Math.round(value * 100);
        else return base;
      }
      return base - Math.min(base, Math.max(0, savings));
    }
    renderDrinks() {
      for (const role of ['booking']) {
        const card = this.querySelector(`[data-drink-card="${role}"]`);
        if (!card) continue;
        const offer = this.data.drinks[role], selection = this.drinks[role];
        const count = Number(Number(this.childInput.value) + Number(this.adults.value));
        const variant = offer.variants.find(v => String(v.id) === String(selection.variant));
        const max = drinkLimit(offer, selection.variant, count, this.cart);

        if (selection.yes && max > 0 && selection.quantity > max) selection.quantity = max;
        const locked = this.busy || Boolean(this.pending);
        const drinkFee = this.drinkFee();
        const priceSuffix = String(this.data.copy.drink_price_suffix || '').trim();
        const price = card.querySelector('[data-drink-price]');
        const extraFee = this.data.fees?.drinksIncluded ? 0 : drinkFee;
        price.replaceChildren();
        if (variant) {
          const discounted = this.drinkPrice(variant);
          if (discounted < variant.price) {
            const original = document.createElement('s'); original.textContent = this.money(variant.price + extraFee);
            original.style.cssText = 'font-size:.8em;font-weight:400;margin-inline-end:.5em;';
            original.setAttribute('aria-label', `Regular price ${original.textContent}`); price.append(original);
          }
          const current = document.createElement('span'); current.textContent = `${this.money(discounted + extraFee)}${priceSuffix ? ' ' + priceSuffix : ''}`;
          if (discounted < variant.price) current.setAttribute('aria-label', `Sale price ${current.textContent}`);
          price.append(current);
        }
        const feeNote = card.querySelector('[data-drink-fee-note]');
        if (feeNote) {
          feeNote.hidden = !variant || !drinkFee;
          feeNote.textContent = drinkFee ? `Includes ${this.money(drinkFee)} fee per drink` : '';
        }
        card.querySelectorAll('[data-drink-choice]').forEach(input => {input.setAttribute('aria-pressed',String(selection.choiceMade && (input.dataset.value === 'yes') === selection.yes)); input.disabled = locked || (input.dataset.value === 'yes' && max === 0);});
        card.querySelector('[data-drink-details]').hidden = !selection.yes;
        const picker = card.querySelector('[data-drink-variant]'); picker.value = String(selection.variant); picker.hidden = offer.variants.length < 2; picker.disabled = locked;
        card.querySelector('[data-drink-variant-label]').hidden = picker.hidden;
        for (const option of picker.options) option.disabled = drinkLimit(offer, option.value, count, this.cart) === 0;
        card.querySelector('[data-drink-quantity]').textContent = String(selection.quantity);
        card.querySelector('[data-drink-delta="-1"]').disabled = locked || selection.quantity <= 1;
        card.querySelector('[data-drink-delta="1"]').disabled = locked || selection.quantity >= max;
        card.querySelector('[data-drink-limit]').textContent = max === 0 ? 'This drink is currently unavailable. You can continue without it.' : selection.yes ? (offer.limitedToTickets ? `Up to ${count} upgrades — one per ticket.` : 'Choose how many specialty drinks you would like.') : '';
      }
    }
    renderNames() {
      const box=this.querySelector('[data-names]'); box.replaceChildren();
      for(let index=0;index<Number(this.childInput.value);index++) {
        const label=document.createElement('label'); label.textContent=this.data.copy.name_label.includes('{number}') ? this.data.copy.name_label.replaceAll('{number}',String(index+1)) : `${this.data.copy.name_label} ${index+1}`;
        const input=document.createElement('input'); input.type='text'; input.required=true; input.maxLength=100;
        input.dataset.childName=String(index); input.name=`child-${index+1}-name`; input.autocomplete='off';
        input.value=this.names[index] || '';
        input.addEventListener('input',()=>{this.names[index]=input.value;input.setCustomValidity(input.value.trim()?'':'Enter this child’s name.');});
        label.append(input); box.append(label);
      }
    }
    clear() {
      this.linked = {choiceMade:false,yes:false,key:null,quantity:1};
      const linkedStep = this.querySelector('[data-step="linked"]'); if (linkedStep) linkedStep.hidden = true;
      this.key = null;
      ['children','guests',...(this.data.hasDrinks ? ['drinks'] : [])].forEach(s => this.querySelector(`[data-step="${s}"]`).hidden = true);
      this.querySelector('[data-times]').hidden=false;
      this.querySelector('[data-time-selection]').hidden=true;
    }
    async request(path, body) {
      const response = await this.fetchWithTimeout((window.Shopify?.routes?.root || '/')+path, {method:body ? 'POST':'GET', cache:'no-store', headers:{'Accept':'application/json', ...(body ? {'Content-Type':'application/json'}:{})}, ...(body ? {body:JSON.stringify(body)}:{})});
      const data = await response.json();
      if (!response.ok) {const error = new Error(data.description || 'We could not update the cart. Please try again.'); error.inventoryRejection = response.status === 422 && /stock|sold out|available|inventory|quantity/i.test(String(data.description || '')); error.definite = response.status >= 400 && response.status < 500 && response.status !== 408 && response.status !== 429; throw error;}
      return data;
    }
    async refresh(launchRefresh = false) {
      if (this.refreshTask) {await this.refreshTask; if (!launchRefresh) return this.refresh(true); return;}
      this.refreshTask = this.fetchSnapshot(launchRefresh);
      try {return await this.refreshTask;} finally {this.refreshTask = null;}
    }
    async fetchSnapshot(launchRefresh = false) {
      const url = new URL(this.data.sourceUrl, location.origin);
      for (const key of ['preview_theme_id', '_fd', 'pb']) {const value = new URL(location.href).searchParams.get(key);if (value !== null) url.searchParams.set(key, value);}
      url.searchParams.set('section_id',this.dataset.sectionId);
      url.searchParams.set('_ds',String(Date.now()));
      const [response, cart] = await Promise.all([this.fetchWithTimeout(url, {cache:'no-store'}), this.request('cart.js')]);
      if (!response.ok) throw new Error('We could not check availability. Please retry.');
      const doc = new DOMParser().parseFromString(await response.text(),'text/html');
      const source = [...doc.querySelectorAll(tag)].find(el => el.dataset.sectionId === this.dataset.sectionId)?.querySelector('[data-booking-data]');
      if (!source) throw new Error('We could not check availability. Please retry.');
      const fresh = JSON.parse(source.textContent);
      if (fresh.mode !== this.data.mode || String(fresh.eventCollectionId) !== String(this.data.eventCollectionId)) {
        throw new Error('The event configuration changed. Please reload the page before booking.');
      }
      if (Boolean(fresh.launch?.enabled) !== Boolean(this.data.launch?.enabled) || fresh.launch?.at !== this.data.launch?.at) throw new Error('The ticket opening schedule changed. Please reload this page before booking.');
      this.data = fresh;
      this.cart = cart;
      await this.refreshDrinkDiscounts();
      this.confirmed = true;
      this.text('[data-freshness]', '');
    }
    async load() {
      if (!this.accessGranted) return;
      if (this.busy) return;
      this.busy = true;
      this.render();
      this.error('');
      try {
        await this.refresh(true);
        this.loaded = true;
        this.text('[data-status]', this.allSlots().length ? diagnosis(this.data) : diagnosis(this.data) || 'No appointment dates are available yet.');
        this.querySelector('[data-retry]').hidden = !this.pending;
        if (this.pending) this.error('A previous booking request needs confirmation. Use Check booking before adding more tickets.');
      } catch (error) {
        this.loaded = false; this.confirmed = false;
        this.text('[data-status]','');
        this.error(error.message);
        this.querySelector('[data-retry]').hidden = false;
      } finally {this.busy = false; this.render();}
    }
    choice(container, label, selected, disabled, className, action) {
      const button = document.createElement('button');
      button.type = 'button'; button.className = className;
      button.setAttribute('aria-label', label);
      const [mainLabel, status] = label.split(' · ');
      const appendText = (text, name) => {
        const span = document.createElement('span');
        span.className = name; span.textContent = text; button.append(span);
      };
      const dateLabel = className === 'ticket-date' && mainLabel.match(/^([^,]+),\s*(.+)$/);
      if (dateLabel) {
        appendText(dateLabel[1], 'ticket-date__day');
        appendText(dateLabel[2], 'ticket-date__date');
      } else appendText(mainLabel, className === 'ticket-time' ? 'ticket-time__value' : 'ticket-date__date');
      if (status) appendText(status, className === 'ticket-date' ? 'ticket-date__status' : 'ticket-time__status');
      button.setAttribute('aria-pressed',String(selected)); button.disabled = disabled || this.busy || !this.loaded || Boolean(this.pending);
      if (status === 'Sold out') {button.classList.add('is-sold-out');}
      button.addEventListener('click',action); container.append(button); return button;
    }
    render() {
      this.updateLaunch();
      const recovery = this.querySelector('[data-cart-recovery]');
      if (recovery) recovery.hidden = !this.pending || !this.querySelector('[data-error]').textContent;
      const waitlist = this.querySelector('[data-waitlist]');
      const waiting = Boolean(waitlist) && (this.launchReady || this.data.waitlistMode === 'always') && waitlistVisible(this.data);
      this.toggleAttribute('data-waitlist-active', waiting);
      this.querySelector('[data-booking-controls]').hidden = waiting;
      this.querySelector('[data-booking-controls]').inert = waiting || !this.accessGranted;
      this.querySelector('.ds-summary').inert = waiting;
      if (waitlist) waitlist.hidden = !waiting;
      const today = new Intl.DateTimeFormat('en-CA',{timeZone:zone,year:'numeric',month:'2-digit',day:'2-digit'}).format(Date.now());
      const list = this.allSlots().filter(s => this.data.availability.pastDates !== 'hide' || s.date >= today), current = list.find(s => s.key === this.key);
      if (this.key && (!current?.available)) {
        this.clear(); this.querySelector('[data-times]').hidden = false; this.querySelector('[data-time-selection]').hidden = true; this.show('time'); this.error('That appointment is no longer available. Your date is saved—please choose another time.');
      }
      const dates = this.querySelector('[data-dates]'); dates.replaceChildren();
      for (const day of [...new Set(list.map(s => s.date))]) {
        const times = list.filter(s => s.date === day), available = times.some(s => s.available || s.cartOnly);
        const past = times.every(s => s.start <= Date.now());
        const label = new Intl.DateTimeFormat('en-US',{timeZone:zone,weekday:'short',month:'short',day:'numeric'}).format(times[0].start);
        if (!available && !past && this.data.availability.soldDates === 'hide') continue;
        const special = this.data.special.enabled && String(this.data.special.dates || '').split(/[\s,;]+/).includes(day);
        this.choice(dates,label+(available?'':past?' · Passed':times.every(s=>s.remaining===0)?' · Sold out':' · Unavailable'),day===this.day,!available,'ticket-date',() => {
          this.day = day; this.clear(); this.error(''); this.render(); this.querySelector('[data-dates]').hidden=true; this.querySelector('[data-date-selection]').hidden=false; this.text('[data-date-value]',label); this.show('time');
        });
        if (special) {
          const button = dates.lastElementChild;
          const badge = document.createElement('small'); badge.className = 'ticket-date__special'; badge.textContent = this.data.special.badge;
          button.append(badge);
          button.setAttribute('aria-label', `${button.getAttribute('aria-label')} — ${this.data.special.badge}`);

        }
        if (this.data.dateImages?.enabled) {
          const button = dates.lastElementChild;
          const source = times.find(s => s.child.image)?.child.image;
          const placeholder = document.createElement('span'); placeholder.className = 'ticket-date__image-placeholder'; placeholder.setAttribute('aria-hidden','true');
          button.classList.add('has-date-image');
          const ratio = ['1 / 1','4 / 3','3 / 2','16 / 9','3 / 4'].includes(this.data.dateImages.ratio) ? this.data.dateImages.ratio : '3 / 2';
          button.style.setProperty('--date-image-ratio',ratio);
          const badge = button.querySelector('.ticket-date__special');
          if (source) {
            const image = document.createElement('img'); image.className = 'ticket-date__image'; image.alt = ''; image.loading = 'lazy'; image.decoding = 'async'; image.src = source;
            if (badge) badge.hidden = true;
            image.addEventListener('error', () => {image.replaceWith(placeholder); if (badge) badge.hidden = false;}, {once:true});
            button.prepend(image);
          } else button.prepend(placeholder);
        }
      }
      this.querySelector('[data-calendar-empty]').hidden = Boolean(dates.children.length) || !this.loaded;
      const times = this.querySelector('[data-times]'); times.replaceChildren();
      for (const slot of list.filter(s => s.date === this.day)) {
        const status = slot.start <= Date.now() ? 'Passed' : slot.cartOnly ? 'In your cart — view cart' : slot.remaining===0 ? 'Sold out' : !slot.configured ? 'Unavailable' : !slot.adult.available ? 'Unavailable' : '';
        if (status === 'Sold out' && this.data.availability.soldTimes === 'hide') continue;
        const availableLabel = remainingLabel(this.data, slot);
        const button = this.choice(times,`${slot.time}${(status || availableLabel) ? " · "+(status || availableLabel) : ""}`,slot.key===this.key,!slot.available && !slot.cartOnly,'ticket-time',() => {
          if (slot.cartOnly) {this.goToCart(); return;}
          this.clear(); this.key=slot.key; this.childInput.max = slot.remaining === Number.MAX_SAFE_INTEGER ? '' : String(slot.remaining); this.error(''); this.render(); this.querySelector('[data-times]').hidden=true; this.querySelector('[data-time-selection]').hidden=false; this.text('[data-time-value]',slot.time); this.show('children');
        });
        button.classList.toggle('is-low', slot.available && Boolean(availableLabel) && slot.remaining > 0 && slot.remaining <= Number(this.data.availability.threshold));

      }
      if (this.key) {
        const slot = this.selected(); this.childInput.max = slot.remaining === Number.MAX_SAFE_INTEGER ? '' : String(slot.remaining);
        this.text('[data-child-price]',this.displayTicketPrice(slot.child.price));
        this.renderTicketFee('main', '[data-child-fee]', slot.child.price);
        this.text('[data-guest-price]',this.displayTicketPrice(slot.adult.price, 'guest'));
        this.renderTicketFee('guest', '[data-guest-fee]', slot.adult.price);
      }
      this.form.querySelectorAll('input').forEach(el => el.disabled=this.busy || Boolean(this.pending));
      this.querySelectorAll('[data-adjust], [data-change-date], [data-change-time]').forEach(el=>el.disabled=this.busy || Boolean(this.pending));
      this.querySelector('[data-continue-children]').disabled=this.busy || Boolean(this.pending);
      this.renderDrinks();
      this.renderLinked();
      this.summary();
      this.scrollToFirstQuestion();
    }
    summary() {
      const slot=this.selected(), c=Number(this.childInput.value), a=Number(this.adults.value);
      this.querySelector('.ds-summary').classList.toggle('is-ready', Boolean(slot));
      const valid=slot?.available && positive(c) && c<=slot.remaining && (this.santa ? positive(a) : a === 0);
      this.text('[data-summary-appointment]', slot ? new Intl.DateTimeFormat('en-US', {timeZone: zone, weekday: 'long', month: 'long', day: 'numeric'}).format(slot.start) : 'Choose a date and time');
      this.text('[data-summary-time]', slot?.time || '');
      this.querySelector('[data-summary-time]').hidden = !slot;
      this.text('[data-summary-children]',slot ? `${positive(c)?c:'—'} × ${c === 1 ? this.data.copy.summary_ticket_singular : this.data.copy.summary_ticket_plural}`:'');
      this.text('[data-summary-guests]',slot && this.santa ? `${positive(a)?a:'—'} × ${a === 1 ? this.data.copy.summary_guest_singular : this.data.copy.summary_guest_plural}`:'');
      this.text('[data-child-total]',slot && positive(c)?this.money(slot.child.price*c):'');
      this.text('[data-guest-total]',slot && positive(a)?this.money(slot.adult.price*a):'');
      let drinkTotal = 0, drinksValid = true;
      for (const role of ['booking']) {
        const selection = this.drinks[role], offer = this.data.drinks[role];
        const variant = offer.variants.find(v => String(v.id) === String(selection.variant));
        const quantity = selection.yes ? selection.quantity : 0;
        if (selection.yes && (!positive(quantity) || quantity > drinkLimit(offer,selection.variant,c + a,this.cart))) drinksValid = false;
        const total = variant ? this.drinkPrice(variant) * quantity : 0; drinkTotal += total;
        this.querySelector(`[data-drink-summary="${role}"]`).hidden = !slot || !quantity;
        this.text(`[data-drink-summary-label="${role}"]`, `${quantity} × ${this.santa ? (quantity === 1 ? "Specialty drink upgrade" : "Specialty drink upgrades") : (quantity === 1 ? "Specialty drink" : "Specialty drinks")}`);
        this.text(`[data-drink-total="${role}"]`,this.money(total));
      }
      try {drinkItems(this.data,this.drinks,c,a,this.cart,{});} catch {drinksValid = false;}
      const linked = this.linkedSelected();
      const linkedTotal = this.linked.yes && linked && positive(this.linked.quantity) ? linked.variant.price * this.linked.quantity : 0;
      this.querySelector('[data-linked-summary]').hidden = !slot || !this.linked.yes || !linked;
      this.text('[data-linked-summary-label]', `${this.linked.quantity} × Walk Through the Lights${linked ? ' · ' + linked.time : ''}`);
      this.text('[data-linked-total]', this.money(linkedTotal));
      const feeCountMain = positive(c) ? c : 0, feeCountGuests = this.santa && positive(a) ? a : 0;
      const feeCountLinked = this.linked.yes && linked && positive(this.linked.quantity) ? this.linked.quantity : 0;
      const fees = ticketFee(this.data) * feeCountMain + ticketFee(this.data, 'guest') * feeCountGuests + ticketFee(this.data, 'linked') * feeCountLinked;
      const feeTickets = (ticketFee(this.data) ? feeCountMain : 0) + (ticketFee(this.data, 'guest') ? feeCountGuests : 0) + (ticketFee(this.data, 'linked') ? feeCountLinked : 0);
      const drinkFeeQuantity = this.data.hasDrinks && this.drinks.booking.yes && positive(this.drinks.booking.quantity) ? this.drinks.booking.quantity : 0;
      const drinkFees = this.drinkFee() * drinkFeeQuantity;
      const combinedFees = fees + drinkFees;
      const includedFees = (this.data.fees?.included ? fees : 0) + (this.data.fees?.drinksIncluded ? drinkFees : 0);
      const breakdown = [];
      if (fees) breakdown.push(`${feeTickets} × ${this.money(this.data.fees.amount)}`);
      if (drinkFees) breakdown.push(`${drinkFeeQuantity} × ${this.money(this.drinkFee())}`);
      const includedNote = includedFees ? (includedFees === combinedFees ? ' — included' : ` — ${this.money(includedFees)} already included`) : '';
      this.querySelector('[data-fee-summary]').hidden = !valid || !combinedFees;
      this.text('[data-fee-summary-label]', `${this.data.fees?.label || 'Fees'}${this.data.fees?.showBreakdown ? ` (${breakdown.join(' + ')})` : ''}${includedNote}`);
      this.text('[data-fee-total]', this.money(combinedFees));
      this.text('[data-summary-total-label]', fees || drinkFees ? this.data.fees.totalLabel || 'Estimated total' : this.data.copy.subtotal_label || 'Subtotal');
      this.text('[data-total]',valid ? this.money(slot.child.price*c+slot.adult.price*a+drinkTotal+linkedTotal+(this.data.fees?.included ? 0 : fees)+(this.data.fees?.drinksIncluded ? 0 : drinkFees)):'');
      this.querySelectorAll('[data-summary-line], [data-summary-note]').forEach(el=>el.hidden=!slot);
      this.querySelector('[data-summary-guests]').parentElement.hidden = !slot || !this.santa;
      this.querySelector('[data-summary-subtotal]').hidden=!valid;
      this.querySelectorAll('[data-adjust]').forEach(el=>{if(el.dataset.delta==='-1')el.disabled=this.busy || Boolean(this.pending) || Number((el.dataset.adjust==='children'?this.childInput:this.adults).value)<=1;});
      const ready = this.linkedValid() && !this.querySelector('[data-step="guests"]').hidden && (!this.data.hasDrinks || (!this.querySelector('[data-step="drinks"]').hidden && this.drinks.booking.choiceMade));
      this.querySelector('[data-final-action]').hidden = !ready;
      this.submit.disabled=!valid || !drinksValid || !ready || this.locked() || !this.loaded || !this.launchReady;
      if (this.querySelector('[data-continue-names]')) this.querySelector('[data-continue-names]').disabled = this.busy || Boolean(this.pending);
      this.submit.textContent=this.busy?'Checking…':this.data.copy.add_label;
    }
    async reconcile() {
      const cart = await this.request('cart.js');
      this.cart = cart;
      const lines = cart.items.filter(line => line.properties?._calendar_request === this.pending.id);
      const complete = this.pending.items.every(item => lines.filter(line => String(line.variant_id) === String(item.id)).reduce((n,line) => n + line.quantity, 0) === item.quantity);
      return complete ? cart : null;
    }
    async removePartial() {
      const cart = await this.request('cart.js');
      const lines = cart.items.filter(line => line.properties?._calendar_request === this.pending.id);
      if (lines.length) await this.request('cart/update.js', {updates: Object.fromEntries(lines.map(line => [line.key, 0]))});
    }
    persistPending() {try {sessionStorage.setItem(this.storageKey, JSON.stringify(this.pending));} catch {}}
    clearPending() {this.pending = null;try {sessionStorage.removeItem(this.storageKey);} catch {}}
    async finish(cart) {
      for (const role of ['booking']) {this.drinks[role].yes=false;this.drinks[role].quantity=0;this.drinks[role].choiceMade=false;}
      this.cart=cart; this.clear(); this.names=[]; this.childInput.value='1'; this.adults.value=this.santa?'1':'0'; this.querySelector('[data-names]').replaceChildren(); this.text('[data-status]','Your tickets have been added to the cart.');
      document.querySelectorAll('.cart-count-total').forEach(el=>{const spans=el.querySelectorAll('span'); if(spans[0])spans[0].textContent=cart.item_count; if(spans[1])spans[1].textContent=`${cart.item_count} items`;});
      if (this.data.directCheckout === true) await this.goToCheckout();
      else this.goToCart();
    }
    async recover() {
      if (!this.accessGranted) return;
      if (this.busy || !this.pending) return;
      this.busy=true;this.error('');this.render();
      try {
        const cart = await this.reconcile();
        if (cart) {this.clearPending();await this.finish(cart);}
        else if (!this.pending.uncertain) {await this.removePartial();this.clearPending();await this.refresh(true);this.error('No complete booking was added. Please review the current availability.');}
        else this.error('The request is still unconfirmed. Please check again or view your cart. We will not send duplicate tickets automatically.');
      } catch {this.error('We could not check your cart. Please use Check booking again when the connection returns.');}
      finally {this.busy=false;this.querySelector('[data-retry]').hidden=!this.pending;this.render();}
    }
    async add() {
      if (!this.launchReady || (this.data.launch?.enabled && !this.presaleGranted && Date.now() < this.launchAt) || waitlistVisible(this.data)) {this.render(); return;}
      if(this.locked() || !this.loaded || this.querySelector('[data-step="guests"]').hidden) return;
      if(!this.validCounts() || !this.linkedValid()) return;
      this.querySelectorAll('[data-child-name]').forEach(input=>input.setCustomValidity(input.value.trim()?'':'Enter this child’s name.'));
      if(!this.validNames()) return;
      if (this.data.hasDrinks && (this.querySelector('[data-step="drinks"]').hidden || !this.drinks.booking.choiceMade)) {this.show('drinks');this.renderDrinks();this.summary();return;}
      const key=this.key,c=Number(this.childInput.value),a=Number(this.adults.value);
      if(!positive(c)||(this.santa ? !positive(a) : a !== 0)) {this.error('Select at least one ticket of each type, using whole numbers.');return;}
      this.busy=true;this.error('');this.render();
      try {
        await this.refresh();
        if (waitlistVisible(this.data)) {this.render(); return;}
        const slot=this.allSlots().find(s=>s.key===key);
        if (slot && c > slot.remaining) throw new Error(this.quantityMessage(slot.remaining, c));
        const id=crypto.randomUUID(),items=itemsFor(slot,c,a,id,this.names.slice(0,c),this.data.mode);
        for (const item of items) {item.properties._calendar_request=id; item.properties._booking_product_url=this.data.sourceUrl;item.properties._booking_section_id=this.data.sectionId;}
        items.push(...drinkItems(this.data,this.drinks,c,a,this.cart,{'_calendar_request':id,...(this.santa ? {'_dear_santa_booking':id,'_booking_product_url':this.data.sourceUrl,'_booking_section_id':this.data.sectionId} : {})}));
        items.push(...this.linkedItems(id));
        this.pending={id,items,createdAt:Date.now(),uncertain:true}; this.persistPending();
        let failure;
        try {await this.request('cart/add.js',{items}); this.pending.uncertain = false; this.persistPending();}
        catch(error) {failure=error; this.pending.uncertain = !error.definite; this.persistPending();}
        const cart=await this.reconcile();
        if (cart) {this.clearPending();await this.finish(cart);}
        else if (!this.pending.uncertain) {
          await this.removePartial(); this.clearPending();
          await this.refresh(true); this.error(failure?.inventoryRejection ? (this.data.copy.cart_unavailable || 'That selection is no longer available in the requested quantity. Please review the refreshed times.') : failure?.message || 'Not all selected tickets were available. No complete booking was added. Please review the refreshed times.');
        } else this.error('The connection was interrupted. Do not add again yet. Use Check booking to confirm whether your tickets reached the cart.');
      } catch(error) {
        if (!this.pending) {try {await this.refresh(true);} catch {this.confirmed=false;}}
        this.error(this.pending ? 'We could not confirm the result. Use Check booking or view your cart before trying again.' : error.message);
      } finally {this.busy=false;this.querySelector('[data-retry]').hidden=!this.pending;this.render();}

    }
  });
})();


(() => {
  if (customElements.get('event-product-calendar')) return;
  customElements.define('event-product-calendar', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.querySelector('[data-fallback-retry]').addEventListener('click', () => this.loadCalendar());
      this.loadCalendar();
    }
    disconnectedCallback() {this.controller?.abort();}
    async loadCalendar() {
      if (this.loading) return;
      this.loading = true;
      const status = this.querySelector('[data-fallback-status]');
      const retry = this.querySelector('[data-fallback-retry]');
      retry.hidden = true;
      this.controller = new AbortController();
      const timer = setTimeout(() => this.controller.abort(), 20000);
      try {
        const url = new URL(this.dataset.source, location.origin);
        if (url.origin !== location.origin) throw new Error('Invalid event URL');
        for (const key of ['preview_theme_id', '_fd', 'pb']) {const value = new URL(location.href).searchParams.get(key);if (value !== null) url.searchParams.set(key, value);}
        url.searchParams.set('_gmf', String(Date.now()));
        const response = await fetch(url, {cache: 'no-store', signal: this.controller.signal});
        if (!response.ok) throw new Error('Could not load event');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const calendars = doc.querySelectorAll('event-calendar');
        if (calendars.length !== 1) throw new Error('Expected one event calendar');
        const source = calendars[0];
        const wrapper = document.createElement('div');
        wrapper.id = `shopify-section-${source.dataset.sectionId}`;
        wrapper.append(document.importNode(source, true));
        this.querySelector('[data-fallback-calendar]').replaceChildren(wrapper);
        status.hidden = true;
      } catch {
        status.hidden = false;
        status.textContent = 'The calendar could not be loaded. Try again or use the main booking-page link above.';
        retry.hidden = false;
      } finally {clearTimeout(timer);this.loading = false;}
    }
  });
})();
